import { trim } from "../../helpers";
import BondLogo from "../../components/BondLogo";
import { Box, Button, Link, Paper, Typography, TableRow, TableCell, SvgIcon, Slide } from "@material-ui/core";
import { ReactComponent as ArrowUp } from "../../assets/icons/arrow-up.svg";
import { NavLink } from "react-router-dom";
import "./choosebond.scss";
import { Skeleton } from "@material-ui/lab";
import useBonds from "src/hooks/Bonds";
import { useTranslation } from 'react-i18next';

export function BondDataCard({ bond }) {
  const { t } = useTranslation();
  const { loading } = useBonds();
  const isBondLoading = !bond.bondPrice ?? true;

  return (
    (bond.name != 'sohm_wbnb_lp_old') ? <Slide direction="up" in={true}>
      <Paper id={`${bond.name}--bond`} className="bond-data-card ohm-card">
        <div className="bond-pair">
          <BondLogo bond={bond} />
          <div className="bond-name">
            <Typography>{bond.displayName}</Typography>
            {bond.isLP && (
              <div>
                {/* <Link href={bond.lpUrl} target="_blank"> */}
                <Link component={NavLink} to={`/bonds/${bond.name}`}>
                  <Typography variant="body1">
                    1-click Purchase
                    <SvgIcon component={ArrowUp} htmlColor="#A3A3A3" />
                  </Typography>
                </Link>
              </div>
            )}
          </div>
        </div>

        <div className="data-row">
          <Typography>{t('bond.price')}</Typography>
          <Typography className="bond-price">
            <>{isBondLoading ? <Skeleton width="50px" /> : `$${trim(bond.bondPrice, 2)}`}</>
          </Typography>
        </div>

        <div className="data-row">
          <Typography>{t('bond.ROI')}</Typography>
          <Typography>{isBondLoading ? <Skeleton width="50px" /> : `${trim(bond.bondDiscount * 100, 2)}%`}</Typography>
        </div>

        <div className="data-row">
          <Typography>{t('bond.purchased')}</Typography>
          <Typography>
            {isBondLoading ? (
              <Skeleton width="80px" />
            ) : (
              // new Intl.NumberFormat("en-US", {
              //   style: "currency",
              //   currency: "USD",
              //   maximumFractionDigits: 0,
              //   minimumFractionDigits: 0,
              // }).format(bond.purchased)
              `$${new Intl.NumberFormat("en-US").format(trim(bond.purchased, 2))}`
            )}
          </Typography>
        </div>
        <Link component={NavLink} to={`/bonds/${bond.name}`}>
          <Button variant="outlined" color="primary" fullWidth disabled={!bond.isAvailable}>
            <Typography variant="h5">
              {!bond.isAvailable ? `Sold Out` : `${t('common.bond')} ${bond.displayName}`}
            </Typography>
          </Button>
        </Link>
      </Paper>
    </Slide> : ""
  );
}

export function BondTableData({ bond }) {
  const { t } = useTranslation();
  // Use BondPrice as indicator of loading.
  const isBondLoading = !bond.bondPrice ?? true;
  // const isBondLoading = useSelector(state => !state.bonding[bond]?.bondPrice ?? true);


  return (
    (bond.name != 'sohm_wbnb_lp_old') ? <TableRow id={`${bond.name}--bond`} >
      <TableCell align="left" className="bond-name-cell">
        <BondLogo bond={bond} />
        <div className="bond-name">
          <Typography variant="body1">{bond.displayName}</Typography>
          {bond.isLP && (
            // <Link color="primary" href={bond.lpUrl} target="_blank">
            <Link component={NavLink} to={`/bonds/${bond.name}`}>
              <Typography variant="body1" style={{ color: "#A3A3A3" }}>
                1-click Purchase
                <SvgIcon component={ArrowUp} htmlColor="#A3A3A3" />
              </Typography>
            </Link>
          )}
        </div>
      </TableCell>
      <TableCell align="left">
        <Typography>
          <>
            {/* <span className="currency-icon">$</span> */}
            {isBondLoading ? <Skeleton width="50px" /> : `$${trim(bond.bondPrice, 2)}`}
          </>
        </Typography>
      </TableCell>
      <TableCell align="left">{isBondLoading ? <Skeleton /> : `${trim(bond.bondDiscount * 100, 2)}%`}</TableCell>
      <TableCell align="right">
        {isBondLoading ? (
          <Skeleton />
        ) : (
          // new Intl.NumberFormat("en-US", {
          //   style: "currency",
          //   currency: "USD",
          //   maximumFractionDigits: 0,
          //   minimumFractionDigits: 0,
          // }).format(bond.purchased)
          `$${new Intl.NumberFormat("en-US").format(trim(bond.purchased, 2))}`
        )}
      </TableCell>
      <TableCell>
        <Link component={NavLink} to={`/bonds/${bond.name}`}>
          <Button variant="outlined" fullWidth color="primary" disabled={!bond.isAvailable}>
            <Typography variant="h6"> {!bond.isAvailable ? t('common.soldout') : t('common.bond')}</Typography>
          </Button>
        </Link>
      </TableCell>
    </TableRow> : ""
  );
}
